export class NativeStandardBackupPolicyPlan {
    'backupSchedules';
    'vaultProtectionMode';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "backupSchedules",
            "baseName": "backupSchedules",
            "type": "Array<NativeStandardBackupSchedules>",
            "format": ""
        },
        {
            "name": "vaultProtectionMode",
            "baseName": "vaultProtectionMode",
            "type": "NativeStandardBackupPolicyPlanVaultProtectionModeEnum",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStandardBackupPolicyPlan.attributeTypeMap;
    }
    constructor() {
    }
}
export var NativeStandardBackupPolicyPlanVaultProtectionModeEnum;
(function (NativeStandardBackupPolicyPlanVaultProtectionModeEnum) {
    NativeStandardBackupPolicyPlanVaultProtectionModeEnum["None"] = "none";
    NativeStandardBackupPolicyPlanVaultProtectionModeEnum["VaultLockGovernance"] = "vault-lock-governance";
    NativeStandardBackupPolicyPlanVaultProtectionModeEnum["VaultLockCompliance"] = "vault-lock-compliance";
    NativeStandardBackupPolicyPlanVaultProtectionModeEnum["AirGapped"] = "air-gapped";
})(NativeStandardBackupPolicyPlanVaultProtectionModeEnum || (NativeStandardBackupPolicyPlanVaultProtectionModeEnum = {}));
